import { createContext } from 'react';
export const BrowserHistoryContext = createContext({
    backStack: []
});